import { render } from "./addProductsModal.vue?vue&type=template&id=33ea245b&scoped=true"
import script from "./addProductsModal.vue?vue&type=script&lang=js"
export * from "./addProductsModal.vue?vue&type=script&lang=js"

import "./addProductsModal.vue?vue&type=style&index=0&id=33ea245b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ea245b"]])

export default __exports__